import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const AllPrivacyPolicy = () => {
    const navigate = useNavigate();
    const [checking, setChecking] = useState(true);

    useEffect(() => {
        const checkExisting = async () => {
            try {
                const res = await axios.get('https://api.sofiasurgicals.com/api/get-PrivacyPolicy');
                // Record exists — go straight to edit
                navigate(`/edit-PrivacyPolicy/${res.data._id}`, { replace: true });
            } catch (err) {
                if (err.response?.status === 404) {
                    // No record yet — go to create form
                    navigate('/add-PrivacyPolicy', { replace: true });
                } else {
                    console.error(err);
                    setChecking(false); // stop spinner, show fallback error below
                }
            }
        };

        checkExisting();
    }, [navigate]);

    if (checking) {
        return <p className="text-center mt-4">Loading Privacy Policy...</p>;
    }

    return <p className="text-center mt-4 text-danger">Failed to load Privacy Policy. Please try again.</p>;
};

export default AllPrivacyPolicy;